import { Card, Descriptions, Row } from "antd";
import classes from "../../../../Etablissements/Etablissements.module.css";
import { useTranslation } from "react-i18next";
import EtapeRepartitionChronologique from "../EtapeRepartitionChronologique/EtapeRepartitionChronologique";
import EtapeAffectationModule from "../EtapeAffectationModule/EtapeAffectationModule";




function EtapeRecapitulatif({ globalData ,setGlobalData,id_session_formation_homologuee,setIsLoading}) {
  const { t, i18n } = useTranslation();
  const generalDataFormationHomologuee = [
    {
      label: "Secteur",
      value: globalData.secteur || "-",
    },
    {
      label: "Sous-secteur",
      value: globalData?.sous_secteur || "-",
    },
    {
      label: "Spécialité",
      value: globalData?.specialite || "-",
    },
    {
      label: "Niveau minimal exigé pour la participation",
      value: globalData?.niveau_requis || "-",
    },
    {
      label: "Diplôme délivrée à la fin de la session",
      value: globalData?.diplome || "-",
    },
    {
      label: "Date d’expiration de l’homologation de la spécialité",
      value: globalData?.date_fin_homologation
        ? globalData?.date_fin_homologation
        : "-",
    },
    {
      label: "Capacité générale (en personnes)",
      value: globalData?.capacite_generale || "-",
    },
    {
      label: "Numéro du groupe",
      value: globalData?.num_grp || "-",
    },
    {
      label: "Date de début de la session de formation",
      value: globalData?.date_debut_session_formation
        ? globalData?.date_debut_session_formation
        : "-",
    },
    {
      label: "Date de fin de la session de formation",
      value: globalData?.date_fin_session_formation
        ? globalData?.date_fin_session_formation
        : "-",
    },
    {
      label:
        "Cette session de formation est-elle concernée par le Chèque Formation ?",
      value: globalData?.cheque_formation || "-",
    },
  ];
 
  return (
    <Row className={classes.listeRow}>
      <Card
        className={classes.listeCard}
        style={{ marginBottom: "40px" }}
        bordered={false}
        title={
          <div
            style={{
              textAlign: i18n?.dir() === "ltr" ? "left" : "right",
              fontSize: "18px",
              fontWeight: "600",
              color: "#195a99",
              marginTop: "20px",
            }}
          >
            {t("Informations de la Formation")}
          </div>
        }
      >
        <Descriptions column={2} layout="vertical" size="small" bordered>
          {generalDataFormationHomologuee?.map((item, index) => (
            <Descriptions.Item label={item?.label} key={index}>
              {item?.value}
            </Descriptions.Item>
          ))}
        </Descriptions>
      </Card>

      <Card
        className={classes.listeCard}
        style={{ marginBottom: "40px" }}
        bordered={false}
        title={
          <div
            style={{
              textAlign: i18n?.dir() === "ltr" ? "left" : "right",
              fontSize: "18px",
              fontWeight: "600",
              color: "#195a99",
            }}
          >
            {t("Répartition chronologique")}
          </div>
        }
      >
             <EtapeRepartitionChronologique globalData={globalData}  setGlobalData={setGlobalData} print={false}/>

      </Card>

{/* <EtapeAffectationModule globalData={globalData} recap={true}/>
 */}
<EtapeAffectationModule
        // globalData={{ ...globalData, modules_planning: globalData?.affectationModules }}
        globalData={globalData}
        recap={true}
         setGlobalData={setGlobalData}
    
        id_session_formation_homologuee={id_session_formation_homologuee}
        setIsLoading={setIsLoading}
      />
     
    </Row>
  );
}

export default EtapeRecapitulatif;
